<template>
  <rs-pagination
    background
    prev-text="上一页"
    next-text="下一页"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="pageNo"
    :page-sizes="[10,50,100,200]"
    :page-size="pageSize"
    layout="total,prev, pager, next, sizes, jumper"
    :total="pageTotal"
  ></rs-pagination>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    pageNo: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageTotal: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("getSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("getCurrentChange", val);
    }
  }
};
</script>
